// extracted by mini-css-extract-plugin
module.exports = {"mainGrid":"main_mainGrid__3jaaU"};